import { useMemo } from "react";

const useStatusColor = (status: any) => {
  return useMemo(() => {
    switch (status) {
      case "active":
      case "Active":
      case "تمت":
      case "Done":
      case "completed":
      case "completed":
        return "#479821";
      case "Cancelled":
      case "cancelled":
      case "blocked":
      case "Blocked":
        return "#C43535";
      case "pending":
      case "Pending":
      case "جاريه":
      case "pending":
        return "#CF953D";
      case "Upcoming":
      case "upcoming":
      case "تم الانشاء":
      case "created":
        return "#00086D";
      default:
        return "#00086D"; // Default color if status doesn't match any case
    }
  }, [status]);
};

export default useStatusColor;
